// extracted by mini-css-extract-plugin
export default {"button":"bh2tV70Xkd1IhwJN3dSI","icon":"yqSrWYTk6Sm6Cuq8Lcfk"};